import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=2d3a1d5a&"
import script from "./UsersList.vue?vue&type=script&setup=true&lang=js&"
export * from "./UsersList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports